module.exports = __webpack_public_path__ + "static/media/arrow_right.45479d61.svg";